import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col inline-grid" }

import { toRefs } from 'vue';
import ChartLegendItem, { ChartLegendItemPropsInterface } from './ChartLegendItem.vue';

interface LegendPropsInterface {
  labels: ChartLegendItemPropsInterface[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Legend',
  props: {
    labels: {}
  },
  setup(__props: any) {

const props = __props;
const { labels } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(labels), (label) => {
      return (_openBlock(), _createBlock(ChartLegendItem, {
        key: label.color,
        title: label.title,
        total: label.total,
        color: label.color
      }, null, 8, ["title", "total", "color"]))
    }), 128))
  ]))
}
}

})